import { BrowserModule } from '@angular/platform-browser';
import { ToastrModule} from 'ngx-toastr';
import { NgModule, LOCALE_ID } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule }    from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';

import es from '@angular/common/locales/es';
import { registerLocaleData } from '@angular/common';
registerLocaleData(es);

import { LoginProvider } from './_helpers';
import { ErrorInterceptor } from './_helpers';
import { CurrencyMaskModule } from "ng2-currency-mask";

//Directivas
import { SoloNumerosEnterosDirective } from './_helpers/solo-numeros-enteros.directive';
import { ApplyRegex } from './_helpers/apply-regex.directive';

import { routing } from './app-routing';

// Plugins
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MzNavbarModule, MzSidenavModule, MzButtonModule, MzInputModule, MzModalModule, 
  MzCollapsibleModule,  MzValidationModule, MzSelectModule, MzDatepickerModule, MzTooltipModule,
  MzSpinnerModule, MzPaginationModule, MzSwitchModule, MzCheckboxModule, MzToastModule, MzCollectionModule,
  MzRadioButtonModule,MzTextareaModule, MzTabModule, MzBadgeModule } from 'ngx-materialize';

import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { NgxDiffModule } from 'ngx-diff';
  
//Services
import { ZeroService } from './_services/zero/zero.service';
import { Globals as ZeroGlobals } from './_services/zero/globals';
import { CatalogosService } from './_services/catalogos.service';
import { OrderByPipe } from './_services/orderBy.pipe';
import { DateOnlyPipe } from './_services/DateOnlyPipe';
import { DatePipeFormat } from './_services/DatePipeFormat';
import { HttpConfigInterceptor } from './interceptor/interceptor';

// Internacionalizacion
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

// funcion para http-loader de ngx/translate
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

import { AppComponent } from './app.component';
import { NavbarComponent } from './semantic/navbar/navbar.component';
import { ModalsComponent } from './semantic/modals/modals.component';
import { CifrascontrolComponent } from './pages/cifrascontrol/cifrascontrol.component';
import { BitacorramovComponent } from './pages/bitacorramov/bitacorramov.component';
import { LoginComponent } from './login';
import { PagenotfoundComponent } from './pages/pagenotfound/pagenotfound.component';
import { SearchEjecutorComponent } from './pages/search-ejecutor/search-ejecutor.component';
import { SearchSupervisorComponent } from './pages/search-supervisor/search-supervisor.component';
import { SearchPrevencionComponent } from './pages/search-prevencion/search-prevencion.component';
import { BinmanagerComponent } from './pages/binmanager/binmanager.component';
import { LoadingComponent } from './semantic/loading/loading.component';
import { BinesAbcComponent } from './pages/bines-abc/bines-abc.component';
import { DetalleBinComponent } from './pages/detalle-bin-sup/detalle-bin-sup.component';
import { DetalleBinPrevComponent } from './pages/detalle-bin-prev/detalle-bin-prev.component'; 
import { DatatableComponent } from './semantic/datatable/datatable.component';

import { ModalDiffComponent } from './pages/bitacorramov/modal-diff/modal-diff.component';
import { AlertasComponent } from './pages/alertas/alertas.component';
import { DetalleAlertaComponent } from './pages/alertas/detalle-alerta/detalle-alerta.component';
import { AlertasService } from './_services/alertas.service';
import { DragAndDropDirective } from './_helpers/copypaste.directive';
import { BlockCopyPasteDirective } from './_helpers/block-copy-paste.directive';

import { ModalsComponentProcEdit } from './semantic/modaleditProc/modaleditProc.component';
import { ModalsComponentDeleteProc } from './semantic/deletemodalProc/deletemodalProc.component';
import { ModalsComponentDeleteIns } from './semantic/deletemodalIns/deletemodalIns.component';
import { AdministracionComponent } from './pages/administracion/administracion.component';
import { ModalsComponentInsEdit} from './semantic/modaleditIns/modaleditIns.component';
import { CamposService } from './_services/campos.service';
import { LoginForgeComponent } from './loginForge/login-forge.component';
import { CookieService } from 'ngx-cookie-service';
import { SessionService } from './_services/session.service';
import { StorageServiceModule } from 'angular-webstorage-service';
import { ModaleditEsquComponent } from './semantic/modaledit-esqu/modaledit-esqu.component';
import { DeletemodalEsquComponent } from './semantic/deletemodal-esqu/deletemodal-esqu.component';
import { DeleteModalPlantillaComponent } from './semantic/deletemodal-plantilla/deletemodal-plantilla.component';
import { ModalEditPlantillaComponent } from './semantic/modal-edit-plantilla/modaledit-plantilla.component';
import { DeleteModalSeccionComponent } from './semantic/deletemodal-seccion/deletemodal-seccion.component';
import { ModalEditSeccionComponent } from './semantic/modal-edit-seccion/modaledit-seccion.component';
import { ModaleditCamposComponent } from './semantic/modaledit-campos/modaledit-campos.component';
import { DeletemodalCampoComponent } from './semantic/deletemodal-campo/deletemodal-campo.component';
import { ConfiguracionComponent } from './pages/configuracion/configuracion.component';
import { DeletemodalConfigEsqComponent } from './semantic/deletemodal-config-esq/deletemodal-config-esq.component';
import { ModaleditConfigEsquComponent } from './semantic/modaledit-config-esqu/modaledit-config-esqu.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { MovimientosAutomaticosComponent } from './pages/movimientos-automaticos/movimientos-automaticos.component';

@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    ModalsComponent,
    ModalsComponentProcEdit,
    ModalsComponentDeleteProc,
    ModalsComponentDeleteIns,
    ModalsComponentInsEdit,
    ModaleditEsquComponent,
    ModalEditPlantillaComponent,
    ModalEditSeccionComponent,
    AdministracionComponent,
    CifrascontrolComponent,
    BitacorramovComponent,
    LoginComponent,
    PagenotfoundComponent,
    SearchEjecutorComponent,
    SearchSupervisorComponent,
    SearchPrevencionComponent,
    BinmanagerComponent,
    LoadingComponent,
    BinesAbcComponent, 
    SoloNumerosEnterosDirective,
    ApplyRegex,
    DragAndDropDirective,
    BlockCopyPasteDirective,
    DetalleBinComponent,
    DetalleBinPrevComponent,
    DatatableComponent,
    ModalDiffComponent,
    AlertasComponent,
    DetalleAlertaComponent,
    
    OrderByPipe, DateOnlyPipe, DatePipeFormat, LoginForgeComponent, ModaleditCamposComponent, DeletemodalCampoComponent, DeletemodalEsquComponent, 
    DeleteModalPlantillaComponent, DeleteModalSeccionComponent, ConfiguracionComponent, DeletemodalConfigEsqComponent, ModaleditConfigEsquComponent, MovimientosAutomaticosComponent

  ],  
  entryComponents: [
    ModalsComponent, ModalsComponentProcEdit, ModalsComponentDeleteProc, 
    ModalsComponentDeleteIns,
    ModalsComponentInsEdit,
    ModaleditEsquComponent,
    ModalEditPlantillaComponent,
    ModalEditSeccionComponent,
    DeletemodalEsquComponent,
    DeleteModalSeccionComponent,
    DeleteModalPlantillaComponent,
    ModaleditCamposComponent,
    ModaleditConfigEsquComponent,
    DeletemodalEsquComponent,
    DeletemodalCampoComponent,
    DeletemodalConfigEsqComponent,
    ModalDiffComponent, 
    LoadingComponent

  ],
  imports: [
    BrowserModule,
    routing,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    FormsModule,
    CurrencyMaskModule,
    StorageServiceModule,
    // Inicia para el transalate
    TranslateModule.forRoot({
      loader: {
        provide : TranslateLoader,
        useFactory : HttpLoaderFactory,
        deps : [ HttpClient]
      }
    }),
    BrowserAnimationsModule, 
    ToastrModule.forRoot(),
    MzButtonModule, MzInputModule, MzValidationModule, MzNavbarModule, MzSidenavModule, MzDatepickerModule,
    MzSelectModule, MzModalModule, MzSpinnerModule, MzCollapsibleModule, MzCheckboxModule, MzSwitchModule, MzRadioButtonModule,
    MzSwitchModule, MzTooltipModule, MzPaginationModule, MzToastModule, MzCollectionModule,MzTextareaModule, MzTabModule, MzBadgeModule,

    NgxDatatableModule, // DataTable
    NgxDiffModule, //Diff
    NgxChartsModule,
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'es-MX' },
    //{ provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    // provider para servicio login fake 
    LoginProvider,
    // Zero Services    
    ZeroService,ZeroGlobals,CatalogosService, AlertasService, CamposService,SessionService,
    { provide: HTTP_INTERCEPTORS, useClass: HttpConfigInterceptor, multi: true },
    CookieService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
